export default "__VITE_ASSET__BvgaM2BQ__"